import { MutationTree } from "vuex";

import { State } from "./state";
import { DashboardMutationTypes as MutationTypes } from "./mutation-types";

export type Mutations<S = State> = {
  [MutationTypes.SET_TOP5_COMPUTERS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_TOP5_COMPUTERS_ERROR](state: S, payload: string): void;
  [MutationTypes.SET_TOP5_GROUPS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_EVENT_TRENDS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_TOP_COMPUTERS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_BLOCKS_OVERTIME](state: S, payload: Array<any>): void;
  [MutationTypes.SET_ALERT_SUMMARY](state: S, payload: Array<any>): void;
  [MutationTypes.SET_COMPANY_OVERVIEW](state: S, payload: Array<any>): void;
  [MutationTypes.SET_KNOWN_THREADS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_TOP5_COMPUTERS_LOADING](
    state: S,
    payload: boolean
  ): void;
  [MutationTypes.SET_KNOWN_THREADS_LOADING](
    state: S,
    payload: boolean
  ): void;
  [MutationTypes.SET_COMPANY_OVERVIEW_LOADING](
    state: S,
    payload: boolean
  ): void;
  [MutationTypes.SET_TOP5_GROUPS_LOADING](
    state: S,
    payload: boolean
  ): void;
  [MutationTypes.SET_ALERT_SUMMARY_LOADING](
    state: S,
    payload: boolean
  ): void;
  [MutationTypes.SET_NUMBER_OF_BLOCKS_BY_TIME](
    state: S,
    payload: Array<any>
  ): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_TOP5_COMPUTERS](state, payload: any) {
    state.top5Computers = payload;
  },
  [MutationTypes.SET_TOP5_COMPUTERS_ERROR](state, payload: any) {
    state.top5ComputersError = payload;
  },
  [MutationTypes.SET_TOP5_COMPUTERS_LOADING](state, payload: any) {
    state.top5ComputersLoading = payload;
  },
  [MutationTypes.SET_TOP5_GROUPS](state, payload: any) {
    state.top5Groups = payload;
  },
  [MutationTypes.SET_TOP5_GROUPS_LOADING](state, payload: any) {
    state.top5GroupsLoading = payload;
  },
  [MutationTypes.SET_EVENT_TRENDS](state, payload: any) {
    state.eventTrends = payload;
  },
  [MutationTypes.SET_TOP_COMPUTERS](state, payload: any) {
    state.topComputers = payload;
  },
  [MutationTypes.SET_BLOCKS_OVERTIME](state, payload: any) {
    state.blocksOverTime = payload;
  },
  [MutationTypes.SET_ALERT_SUMMARY](state, payload: any) {
    state.alertSummary = payload;
  },
  [MutationTypes.SET_COMPANY_OVERVIEW](state, payload: any) {
    state.companyOverview = payload;
  },
  [MutationTypes.SET_COMPANY_OVERVIEW_LOADING](state, payload: any) {
    state.companyOverviewLoading = payload;
  },
  [MutationTypes.SET_ALERT_SUMMARY_LOADING](state, payload: any) {
    state.alertSummaryLoading = payload;
  },
  [MutationTypes.SET_KNOWN_THREADS_LOADING](state, payload: any) {
    state.knownThreadsLoading = payload;
  },
  [MutationTypes.SET_KNOWN_THREADS](state, payload: any) {
    state.knownThreads = payload;
  },
  [MutationTypes.SET_NUMBER_OF_BLOCKS_BY_TIME](state, payload: any) {
    state.numberOfBlocksByTime = payload;
  },
};
